import { io } from 'socket.io-client';
import { getUser } from '../utils/user-manager';

let socket; // Armazena a instância única

const getSocketInstance = async () => {
    try {
        const url = process.env.REACT_APP_WEBSOCKET_URL || window.location.origin;
        const user = await getUser();
        const newToken = user?.access_token;

        if (!socket) {
            const auth = newToken ? { token: newToken } : undefined;

            socket = io(url, {
                transports: ["websocket", "polling"],
                auth,
            });

            socket.connect();
        } else {
            // Check if token changed or needs to be set
            const currentToken = socket.auth?.token;
            if (currentToken !== newToken) {
                socket.auth = { ...socket.auth, token: newToken };
                // Force a reconnect to apply the new auth
                if (socket.connected) {
                    socket.disconnect().connect();
                } else {
                    socket.connect();
                }
            } else if (!socket.connected) {
                // Ensure it tries to connect if not connected
                socket.connect();
            }
        }
    } catch (error) {
        console.error('Erro ao obter token ou ao criar a instância do socket:', error);
    }
    return socket;
};

export default getSocketInstance;
